import React from "react";

const Header = ({ text }) => {
  return <p className="text-2xl align-left text-white">{text}</p>;
};

export default Header;
